import { AppError } from './chunk-LXZM66LA.mjs';
import { Provider, ErrorBoundary as ErrorBoundary$1 } from '@rollbar/react';
import { jsx } from 'react/jsx-runtime';

var ErrorBoundary = (props) => {
  const { children, config, FallbackComponent } = props;
  return /* @__PURE__ */ jsx(Provider, { config, children: /* @__PURE__ */ jsx(
    ErrorBoundary$1,
    {
      fallbackUI: ({ error }) => {
        if (error instanceof AppError) {
          return /* @__PURE__ */ jsx(
            FallbackComponent,
            {
              errorMessage: error.errorMessage,
              canRetry: error.canRetry
            }
          );
        }
        return /* @__PURE__ */ jsx(
          FallbackComponent,
          {
            errorMessage: "Something went wrong",
            canRetry: false
          }
        );
      },
      children
    }
  ) });
};

export { ErrorBoundary };
//# sourceMappingURL=chunk-XNNSHIX4.mjs.map
//# sourceMappingURL=chunk-XNNSHIX4.mjs.map